module.exports = __webpack_public_path__ + "img/pamm-c1-en.a0bcc0aa.png";